export default function relativeUrl(path, params) {
  const query = new URLSearchParams(params);
  return `${path}?${query.toString()}`;
}
